import { render, staticRenderFns } from "./scoredetail.vue?vue&type=template&id=0a14384c&scoped=true"
import script from "./scoredetail.vue?vue&type=script&lang=js"
export * from "./scoredetail.vue?vue&type=script&lang=js"
import style0 from "./scoredetail.vue?vue&type=style&index=0&id=0a14384c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14384c",
  null
  
)

export default component.exports